import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import settings from "../settings";
import { getClientProps } from "../utils";

const { operator, widgetSettingsType, baseApiUrl, vaixClientId } = settings;

const currentOperator = operator || vaixClientId;

export const widgetSettingsApi = createApi({
  reducerPath: "widgetApi",
  baseQuery: fetchBaseQuery({
    baseUrl: baseApiUrl,
    prepareHeaders: (headers, { getState }) => {
      const { apiAuthToken } = getClientProps();
      headers.set("authorization", `Bearer ${apiAuthToken}`);
      headers.set("Origin", "");
      vaixClientId && headers.set("x-vaix-client-id", vaixClientId);

      return headers;
    },
  }),
  endpoints: (builder) => ({
    getWidgetSettings: builder.query({
      query: () => ({
        url: `/api/ui/settings/`,
        params: {
          filters: `type:eq:${widgetSettingsType};operator:eq:${currentOperator}`,
          operator: currentOperator,
        },
      }),
      transformResponse: (response) => response.data[0].data.pages,
    }),
  }),
});
